import React from "react";

import InvoiceFieldsChile from "./invoice_fields/InvoiceFieldsChile";
import InvoiceFieldsColombia from "./invoice_fields/InvoiceFieldsColombia";
import InvoiceFieldsGeneral from "./invoice_fields/InvoiceFieldsGeneral";

const TaxId = ({
  billingCountry,
  type,
  systemFields,
  information,
  handleShowBilling,
  handleBlurTaxID,
  errors,
  changeStoreField,
  invoiceFields,
  setInvoiceFields,
  isAdressForm = false,
}) => {
  if (!systemFields.taxid_enabled) return null;

  if (type !== "billing") return null;

  const isSameAsShipping = information?.billing_same_as_shipping;
  const noShipping =
    information?.no_shipping_required ||
    information?.shipping_option === "no_shipping" ||
    information?.shipping_option === "store_pickup";
  const showBilling = handleShowBilling?.();

  if (isAdressForm) {
    if (billingCountry === "CL") {
      return (
        <InvoiceFieldsChile
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          invoiceFields={invoiceFields}
          setInvoiceFields={setInvoiceFields}
          isAdressForm={true}
        />
      );
    }
    if (billingCountry === "CO") {
      return (
        <InvoiceFieldsColombia
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          invoiceFields={invoiceFields}
          setInvoiceFields={setInvoiceFields}
          isAdressForm={true}
        />
      );
    }
    if (billingCountry !== "CO" && billingCountry !== "CL") {
      return (
        <InvoiceFieldsGeneral
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          isAdressForm={true}
        />
      );
    }
  }
  if (isSameAsShipping) {
    if (
      (!showBilling && information.country == "CL") ||
      (billingCountry === "CL" && information?.shipping_option === "delivery")
    ) {
      return (
        <InvoiceFieldsChile
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          invoiceFields={invoiceFields}
          setInvoiceFields={setInvoiceFields}
          isAdressForm={true}
        />
      );
    }
    if (
      (!showBilling && information.country == "CO") ||
      (billingCountry === "CO" && information?.shipping_option === "delivery")
    ) {
      return (
        <InvoiceFieldsColombia
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          invoiceFields={invoiceFields}
          setInvoiceFields={setInvoiceFields}
          isAdressForm={true}
        />
      );
    }
    if (
      (!showBilling &&
        information.country != "CL" &&
        information.country != "C0") ||
      (information.shipping_option == "delivery" &&
        billingCountry != "CL" &&
        billingCountry != "CO")
    ) {
      return (
        <InvoiceFieldsGeneral
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          isAdressForm={true}
        />
      );
    }
  }
  if (noShipping) {
    if (
      information.country === "CL" &&
      !showBilling &&
      information?.shipping_option === "no_shipping"
    ) {
      return (
        <InvoiceFieldsChile
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          invoiceFields={invoiceFields}
          setInvoiceFields={setInvoiceFields}
          isAdressForm={true}
        />
      );
    }
    if (
      information.country === "CO" &&
      !showBilling &&
      information?.shipping_option === "no_shipping"
    ) {
      return (
        <InvoiceFieldsColombia
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          invoiceFields={invoiceFields}
          setInvoiceFields={setInvoiceFields}
          isAdressForm={true}
        />
      );
    }
    if (
      information.country !== "CL" &&
      information.country !== "CO" &&
      !showBilling &&
      information?.shipping_option === "no_shipping"
    ) {
      return (
        <InvoiceFieldsGeneral
          handleBlurTaxID={handleBlurTaxID}
          errors={errors}
          changeStoreField={changeStoreField}
          isAdressForm={true}
        />
      );
    }
  }

  return null;
};

export default TaxId;
